import type { ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

const studioOptInBannerSource = 'studioOptInBanner';

const studioOptInInfoModal = 'studioOptInInfoModal';
const studioOptInConfirmationModal = 'studioOptInConfirmationModal';
const studioOptInInProgressModal = 'studioOptInInProgressModal';
const studioOptInInCompletedModal = 'studioOptInInCompletedModal';

/** Ordered modal screen sources for mapping currentScreenIndex to analytics source. */
export const STUDIO_OPT_IN_MODAL_SOURCE_ORDER: readonly string[] = [
  studioOptInInfoModal,
  studioOptInConfirmationModal,
  studioOptInInProgressModal,
  studioOptInInCompletedModal,
];

const STUDIO_PRODUCT_ID = 'dbe4d391-d570-4313-ab0f-3a02dbab4720';

const studioEventAttributes = { productId: STUDIO_PRODUCT_ID };

export const studioChangeoverEvents = {
  screen: {
    studioChangeoverBannerScreenEvent: (): ScreenEvent => ({
      data: {
        name: studioOptInBannerSource,
        attributes: studioEventAttributes,
      },
    }),
    studioOptInInfoModalScreenEvent: (): ScreenEvent => ({
      data: { name: studioOptInInfoModal, attributes: studioEventAttributes },
    }),
    studioOptInConfirmationModalScreenEvent: (): ScreenEvent => ({
      data: { name: studioOptInConfirmationModal, attributes: studioEventAttributes },
    }),
    studioOptInInProgressModalScreenEvent: (): ScreenEvent => ({
      data: { name: studioOptInInProgressModal, attributes: studioEventAttributes },
    }),
    studioOptInInCompletedModalScreenEvent: (): ScreenEvent => ({
      data: { name: studioOptInInCompletedModal, attributes: studioEventAttributes },
    }),
  },
  ui: {
    joinBetaButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'optIn',
        source: studioOptInBannerSource,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    learnMoreLinkClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'studioOptInLearnMore',
        source: studioOptInBannerSource,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    dismissButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.DropdownItem,
        actionSubjectId: 'studioOptInDismissButton',
        source: studioOptInBannerSource,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    getStartedButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'optInInfoProceed',
        source: studioOptInInfoModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    screen1CancelButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'optInInfoCancel',
        source: studioOptInInfoModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    screen1LearnMoreLinkClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'optInInfoLearnMore',
        source: studioOptInInfoModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    screen2CancelButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'optInConfirmationCancel',
        source: studioOptInConfirmationModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    screen2LearnMoreLinkClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'optInConfirmationLearnMore',
        source: studioOptInConfirmationModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    screen2UpdateStudioButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'optInConfirmationProceed',
        source: studioOptInConfirmationModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    screen4GotoAppsListButtonClicked: (attributes: { isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'appList',
        source: studioOptInInCompletedModal,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
    modalCloseButtonClicked: (attributes: { source: string; isVortexOrg: boolean }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'modalClose',
        source: attributes.source,
        attributes: { ...studioEventAttributes, ...attributes },
      },
    }),
  },
};
